import React from "react";
import * as dc from "dc";
import * as d3 from "d3";
import reductio from "reductio";
import { ChartTemplate } from "../chartTemplate";
import { Include_bins } from "../../helper/include_bins";
const number_ofmarkets_ChartFunc = (divRef, ndx) => {
  const dist_types = ndx.dimension((d) => d.distribution_Types);
  const dist_types_grp = dist_types
    .group()
    .reduceSum((d) => d.numberdist_channels);

  const number_markets_Chart = dc.numberDisplay(divRef);
  number_markets_Chart
    .formatNumber(d3.format(",.0f"))
    .group(Include_bins(dist_types_grp, "Markets"))
    .valueAccessor((d) => {
      return d.value;
    });
  return number_markets_Chart;
};

export const NumberOfMarketsCrops = (props) => (
  <ChartTemplate chartFunction={number_ofmarkets_ChartFunc} />
);
